/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {applyPolyfills, defineCustomElements} from '@littlerobotfriends/sotsc-game/loader'
import {AspectRatioBox, AspectRatioBoxBody} from 'baseui/aspect-ratio-box'
import {Card} from 'baseui/card'
import React from 'react'
import PageScaffold from '../../components/app/page-scaffold'
import {BaseLayout} from '../../components/layout'
import {routes} from '../../utils/config'

const Game = () => {
  return (
    <BaseLayout>
      <PageScaffold pageTitle={routes.game.name}>
        <Card>
          <AspectRatioBox aspectRatio={4 / 3}>
            <AspectRatioBoxBody overflow="hidden">
              <sotsc-home-screen />
            </AspectRatioBoxBody>
          </AspectRatioBox>
        </Card>
      </PageScaffold>
    </BaseLayout>
  )
}

applyPolyfills().then(() => {
  defineCustomElements()
})

export default Game
